import React, {createContext, useContext, useState} from 'react'

export type MousePosition = {x: number; y: number} | null
const MousePositionContext = createContext<{
  mousePosition: MousePosition
  setMousePosition: (value: MousePosition) => void
}>(null)

export function MousePositionProvider(props: React.PropsWithChildren) {
  const [mousePosition, setMousePosition] = useState<MousePosition>(null)

  return (
    <MousePositionContext.Provider value={{mousePosition, setMousePosition}}>
      {props.children}
    </MousePositionContext.Provider>
  )
}

export function useMousePositionContext() {
  return useContext(MousePositionContext)
}
